import { initials } from "@dicebear/collection";
import { createAvatar } from "@dicebear/core";
import clsx from "clsx";
import { useMemo } from "react";

interface User {
  name?: string | null;
  email: string;
  photo_url?: string | null;
}

interface UserAvatarProps {
  size?: string;
  user: User;
}

export default function UserAvatar({ size, user }: UserAvatarProps) {
  const { name, email, photo_url } = user;

  const avatar = useMemo(() => {
    return createAvatar(initials, {
      seed: name || email,
      size: 64,
      randomizeIds: true,
      radius: 50,
      fontWeight: 700,
    }).toDataUri();
  }, [name, email]);

  const image_src = photo_url || avatar;

  const imageclass = clsx(
    "rounded-full",
    !size && "h-[28px] w-[28px]",
    size === "medium" && "h-14 w-14",
  );

  return (
    <img className={imageclass} src={image_src} width="28" height="28" alt="Avatar" title={email} />
  );
}
